module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1012.467eb4d2.png";